import { localStorageRemove, localStorageSet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

/**
 * Memorizes the displayed logo, or forgets it when `null`. A write that fails (quota) leaves no copy
 * rather than a stale one, and never surfaces an error.
 */
const recordDisplayedLogo = (dataUrl: string | null): void => {
	if (dataUrl === null) {
		localStorageRemove(LOCAL_STORAGE_KEYS.DISPLAYED_LOGO);
		return;
	}

	try {
		localStorageSet(LOCAL_STORAGE_KEYS.DISPLAYED_LOGO, dataUrl);
	} catch {
		localStorageRemove(LOCAL_STORAGE_KEYS.DISPLAYED_LOGO);
	}
};

export default recordDisplayedLogo;
